import React from 'react'

import { Wrapper } from 'Components/UI'
import { ProjectNeighborData } from 'Data/types'

import NextButton from './nextButton'
import { Container, Content } from './styles'

type Props = {
  prevProject?: ProjectNeighborData
  nextProject?: ProjectNeighborData
}

// Neighbors come from the case-page server component (Data/Projects order)
// — previously they were read from a client store that was only populated
// after visiting /work, so the paginator was empty at SSR and on direct
// case-page loads.
function ProjectPaginator({ prevProject, nextProject }: Props) {
  if (!prevProject && !nextProject) {
    return null
  }

  return (
    <Container>
      <Wrapper>
        <Content
          gap={[16, 16, 32]}
          gridTemplateColumns={['1fr', '1fr', `repeat(2, minmax(150px, 1fr))`]}
        >
          <NextButton data={prevProject} prev />

          <NextButton data={nextProject} />
        </Content>
      </Wrapper>
    </Container>
  )
}

export default ProjectPaginator
